import { EMPTY_POLL_FILTERS } from './elements';

class PollsDelegate {
    setFilters(filters) {
        this.setState({ filters: filters || EMPTY_POLL_FILTERS });
    }
}

export default PollsDelegate;
